<script setup lang="ts">
defineProps<{
  title?: string
  subtitle?: string
}>()
</script>

<template>
  <section class="lp-card app-card">
    <header v-if="title || subtitle || $slots.actions || $slots.header" class="app-card__header">
      <div>
        <h2 v-if="title" class="app-card__title">
          {{ title }}
        </h2>
        <p v-if="subtitle" class="app-card__subtitle">
          {{ subtitle }}
        </p>
        <slot name="header" />
      </div>

      <div v-if="$slots.actions">
        <slot name="actions" />
      </div>
    </header>

    <slot />

    <footer v-if="$slots.footer">
      <slot name="footer" />
    </footer>
  </section>
</template>
